export default __webpack_public_path__ + "static/media/swissimunity@2x.6d2a11a9.jpg";